export const locale = {
    lang: "es",
    data: {
        NAV: {
            CADASTROS_SUPER_ADMIN: "Super Admin",
            USERS: "Usuarios",
            BULK_COURSE_SUBSCRIPTION: "Inscripciones masivas",
            INVITES: "Invitaciones",
            ADMINS: "Administradores",
            APP: "Volver al APP",
            SUBPLATFORM: "Sub Plataforma",
            SUBSCRIPTIONS: "Suscripciones",
            DOWNLOADS: "Downloads",
            CERTIFICATES: "Certificados",
            CALENDARS: "Calendarios",
            UPLOAD_FILE: "Importação de dados",
            SUBSCRIPTIONTYPES: "Tipos de suscripción",
            SUBSCRIPTION_DATA: "Datos",
            SUPPORT_CONTACTS: "Contactos para Soporte",
            SUBSCRIPTION_THEME: "Tema",
            SUBSCRIPTION_USER_FIELDS: "Datos adicionales (Usuarios)",
            SUBSCRIPTION_FOOTER: "Pie de firma",
            SUBSCRIPTION_LOGIN_SETTINGS: "Pantalla de inicio de sesión",
            SUBSCRIPTION_COURSES_CATALOG: "Catálogo de Cursos",
            SUBSCRIPTION_COURSES_CATALOG_OLD: "Catálogo de Cursos (Antiguo)",
            SUBSCRIPTION_CERTIFICATION: "Certificado",
            SUBSCRIPTION_CONTRACT: "Contrato",
            SUBSCRIPTION_PRIVACY_POLICY: "Política de Privacidad",
            HOST_CONFIG: "Host",
            SUBSCRIPTION_TEMRS_OF_USE: "Términos de uso",
            SUBSCRIPTION_TERMS_OF_PURCHASE: "Términos de compra",
            PLATFORM_CUSTOMIZATION: "Personalización de la plataforma",
            POLICIES_TERMS: "Políticas y términos",
            COMPANY_INFORMATION: "Información de la empresa",
            COURSES: "Cursos (Inscritos)",
            PLANS: "Planes",
            HOME: "Inicio",
            CONFIGURACOES: "Configuraciones",
            TROCASENHA: "Cambiar contraseña",
            DATA: "Datos",
            ANALYTICS: "Analytics",
            BILLS: "Facturas",
            GROUPS: "Grupos",
            CATEGORIES: "Categorías",
            TEMPLATES: "Plantillas",
            DOCS: "Documentación",
            LEARNING_PATH: "Rutas de aprendizaje",
            ACHIEVEMENTS: "Logros",
            CHECKOUT: "Checkout",
            BILLING_ACCOUNTS: "Cuentas",
            EAD: "EAD",
            CADASTROS: "Registros",
            PAYMENTS: "Pagos",
            CONFIGURATIONS: "Configuraciones",
            AFFILIATES: "Afiliados",
            SPLITRULE: "División de pagos",
            COUPONS: "Cupones",
            COUPONS_SALES_HISTORY: "Historial de ventas",
            IUGU: {
                REPORT: "Informe"
            },
            DATA_ANALYSIS_SETTINGS: "Herramientas de Analytics",
            FISCAL: "Fiscal",
            INVOICE_GATEWAYS: "Gateways",
            INVOICE_REPORT: "Facturas",
            WEBHOOKS_CONFIGS: "Configuraciones",
            WEBHOOKS_EVENTS: "Eventos",
            STORAGE: {
                TITLE: "Biblioteca",
                REPORT: "Informe de consumo"
            },
            GAMIFICATION: {
                TITLE: "Gamificación",
                GAMIFICATION_CONFIGS: "Configuraciones",
                ACHIEVEMENTS: "Logros",
                RANKINGS: "Rankings",
                LEADERBOARDS: "Clasificaciones",
                REPORT: "Informe",
                DETAILS: "Puntuaciones"
            },
            RelatorioGraficos: "Informes y Gráficos"
        }
    }
};
